import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserList } from '../../../../interfaces/interface-bakend/seguridad/users/personas.interface';
import { PersonasService } from '../../../../services/shared/personas.service';
import { User } from '../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { MatDialog } from '@angular/material/dialog';
import { ModalDetalleGecrosComponent } from '../modal-detalle-gecros/modal-detalle-gecros.component';
import { ModalDetalleComponent } from '../modal-detalle/modal-detalle.component';
import { GuiMsjService } from '@services/shared/gui-msj.service';
import { SignoSede } from '@interfaces/interface-bakend/entidades/signo-sede.interface';
import { SignoSedeService } from '@services/entidades/signo-sedes.service';
import { PreviousRouteService } from '@services/shared/previous-route.service';
import Swal from 'sweetalert2';
import { UsuarioService } from '@services/shared/usuario.service';
import { CursosService } from 'src/app/services/cursos/cursos.service';
import { AlumnoTitulo } from '@interfaces/interface-bakend/cursos/titulo.interface';
import { ModalModificarClaveUsersComponent } from '../modal-modificar-clave/modal-modificar-clave.component';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

@Component({
    selector: 'app-personas-listado',
    templateUrl: './personas-listado.component.html',
    styleUrls: ['./personas-listado.component.scss'],
})
export class PersonasListadoComponent implements OnInit, AfterViewInit {
    /* Data Table*/

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = [
        'nombre',
        'apellido',
        'nacionalidad',
        'identificacion',
        'fechaNacimiento',
        'email',
        'telefono',
        '_id',
    ];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    personas: UserList[];

    /* Fin Data Table*/

    routes: { url: string; label: string }[] = [];

    usuarioLoad = false;
    flagLoaded = true;
    flagBuscando = false;
    searchPerformed = false;
    sedes: SignoSede[];

    searchTerm: string = '';

    constructor(
        private personasService: PersonasService,
        private router: Router,
        private previousRouteService: PreviousRouteService,
        public dialog: MatDialog,
        private guiMsjService: GuiMsjService,
        private signoSedeService: SignoSedeService,
        private usuariosService: UsuarioService,
        private cursosService: CursosService,
        private modalCustom: PopUpModalCustomService,
    ) {}

    ngOnInit(): void {
        this.previousRouteService.getRoutes().subscribe((routes) => {
            this.routes = routes;
        });
    }

    ngAfterViewInit(): void {
        // Sin carga automática: el listado se llena con el buscador (comportamiento
        // histórico). Sólo se enganchan paginador y sort a la fuente actual.
        if (this.dataSource) {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    verDetalle(idSede: string, idUser: string): void {
        const dialogRef = this.dialog.open(ModalDetalleComponent, {
            width: '620px',
            maxHeight: '90vh',
            disableClose: true,
            panelClass: 'ds-dialog',
            data: { idUser, idSede },
        });

        dialogRef.afterClosed().subscribe((resp) => {});
    }

    async verDetalleGecros(user: User) {
        const dialogRef = this.dialog.open(ModalDetalleGecrosComponent, {
            width: '900px',
            maxHeight: '90vh',
            disableClose: true,
            panelClass: 'ds-dialog',
            data: user,
        });

        dialogRef.afterClosed().subscribe((resp) => {});
    }

    async getSedes() {
        this.sedes = await this.signoSedeService.getSedes();
    }

    async verPersona(id: string) {
        await this.guiMsjService.msjFormSubmit('Espere');
        Swal.showLoading();
        this.personasService.setPersonaSeleccionada(
            await this.personasService.getById(id),
        );
        console.log(await this.personasService.getPersonaSeleccionada());
        Swal.close();
        this.router.navigateByUrl('/afiliado-modificacion');
    }

    async loadDataTable() {
        const personas = await this.personasService.getAllPersonas();
        this.dataSource = new MatTableDataSource(personas || []);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    async loadDataPage() {
        this.flagLoaded = false;
        try {
            await this.loadDataTable();
        } catch (error) {
            console.error('Error al cargar los afiliados:', error);
            this.dataSource = new MatTableDataSource<any>([]);
        } finally {
            this.flagLoaded = true;
        }
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        if (!this.dataSource) {
            return;
        }
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    async verUsuario(_id: string) {
        await this.usuariosService.getFindOne(_id);
        this.router.navigate(['/usuario-modificacion'], {
            queryParams: { desdeAfiliados: true },
        });
    }

    /* Modal Modificar Clave */
    async openDialogModificarClave(idUsuario: string): Promise<void> {
        const user = await this.usuariosService.getFindOne(idUsuario);

        if (user && user.pin) {
            this.modalCustom.abrirPopup({
                tipo: 'warning',
                titulo: 'Usuario pendiente de activación',
                mensaje:
                    'Este usuario todavía no activó su cuenta. ' +
                    'El <strong>PIN pendiente</strong> indica que aún debe validar su correo electrónico. ' +
                    'Primero debe ingresar el PIN recibido por email para confirmar que el correo es correcto ' +
                    'y activar su cuenta.<br><br>' +
                    '<strong>Luego recién podrá modificarse la contraseña.</strong>',
                textoBoton: 'Entendido',
                ancho: '480px',
            });
            return;
        }

        const dialogRef = this.dialog.open(ModalModificarClaveUsersComponent, {
            width: '620px',
            maxHeight: '90vh',
            disableClose: true,
            panelClass: 'ds-dialog',
            data: idUsuario,
        });

        dialogRef.afterClosed().subscribe((resp) => {});
    }

    async searchPersonas() {
        const term = (this.searchTerm || '').trim();
        if (!term) {
            return;
        }

        this.flagBuscando = true;
        this.flagLoaded = false;
        this.searchPerformed = true;

        const data = {
            searchTerm: term,
        };

        try {
            const personas =
                await this.personasService.getAllPersonasByTerm(data);
            this.dataSource = new MatTableDataSource(personas || []);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        } catch (error) {
            console.error('Error en búsqueda:', error);
        } finally {
            this.flagBuscando = false;
            this.flagLoaded = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.searchPerformed = false;
        this.dataSource = new MatTableDataSource<any>([]);
    }
}
